import { render } from "./TheGiaiThiDauTheThao.vue?vue&type=template&id=6c4d418f"
import script from "./TheGiaiThiDauTheThao.vue?vue&type=script&lang=js"
export * from "./TheGiaiThiDauTheThao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__